import { Box, Stack } from '@mui/material'
import React, { Children, type ReactNode } from 'react'

interface StackLayoutProps {
  children: ReactNode[] | ReactNode
  childMaxWidth?: number | string
}

const StackColumnLayout: React.FunctionComponent<StackLayoutProps> = ({ children, childMaxWidth }) => {
  const childrenArray = Children.toArray(children)

  return (
    <Stack direction='column' alignItems='center'>
      {
        Children.map(childrenArray, (child, index) => {
          return (
            <Box
              width={1}
              maxWidth={childMaxWidth != null ? childMaxWidth : '1900px'}
            >
              {child}
            </Box>
          )
        })
      }
    </Stack>
  )
}

export default StackColumnLayout
